import axios from 'axios'
import store from '../store'
import router from '@/router'
import { MessageBox } from 'mint-ui'
import { getUserToken , getWxConfigType , getWxConfigId ,getScanUrl ,getServicerCode ,getWxAllianceCode ,getWxAgentCode} from '@/store/cookie'



// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000, // 请求超时时间
  withCredentials: true,
})

// request拦截器
service.interceptors.request.use(config => {
  

  if (getUserToken()) {
    config.headers['userToken'] = getUserToken() // 让每个请求携带自定义user_token请根据实际情况自行修改
  }
  if (getWxConfigId()) {
     config.headers['wxConfig'] = getWxConfigId() // 让每个请求携带自定义wx_config请根据实际情况自行修改
  }

  if(config.method=="get" || config.method=="delete" || config.method=="put" ){
     config.params['alliance_code'] =  getWxAllianceCode()
     config.params['agent_code'] =  getWxAgentCode()
  }else{
     config.data['alliance_code'] =  getWxAllianceCode()
     config.data['agent_code'] =  getWxAgentCode()
  }
 

  if(store.getters.user_detail && store.getters.user_detail.user){
      let userId = store.getters.user_detail.user.id
      let userName = store.getters.user_detail.user.name ? store.getters.user_detail.user.name : ''
      if(config.method=="get" || config.method=="delete" || config.method=="put"){
        config.params['user_id'] = userId
         if(!config.params.hasOwnProperty('user_name')){
            config.params['user_name'] = userName
          }
      }
      if(config.method=="post"){
         config.data['user_id'] = userId
          if(!config.data.hasOwnProperty('user_name')){
            config.data['user_name'] = userName
          }
      }
  }

   
  if(store.getters.company_main && store.getters.company_main.company_id){
      let companyId = store.getters.company_main.company_id
      if(config.method=="get" || config.method=="delete" || config.method=="put" ){
        //追加判断  如果有传过来公司id 刚使用主公司id
        if(!config.params.hasOwnProperty('company_id')){
           config.params['company_id'] = companyId 
        }
      }
      if(config.method=="post"){
        if(!config.data.hasOwnProperty('company_id')){
           config.data['company_id'] = companyId 
        }
      }
  }

 
  return config
  
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
    * code为是抛错 可结合自己业务进行修改
    */
    const res = response.data
    // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
    if (res.code === 40003 || res.code === 40004 || res.code === 40005 ||  res.code === 400056) {
      MessageBox.confirm('登录过期，你已被登出', '确定登出').then(() => {
        store.dispatch('EmptyUserToken').then(() => {
          //清空数据后跳转到check
            router.push('/bind/authCheck')
            return res
          //location.reload()// 为了重新实例化vue-router对象 避免bug
        })
      })
    }
    return res

  },
  error => {
    console.log('err' + error)// for debug
    MessageBox.alert(error.message).then(() => {
        
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js